import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  memberFilter: [],
  detailsFilter: [],
  statusFilter: [],
  sorting: [],
  memberSearch: "",
  detailsSearch: "",
  statusSearch: "",
};

const internationalFilterSlice = createSlice({
  name: "internationalFilters",
  initialState,
  reducers: {
    setInternationalFilters(state, action) {
      return { ...state, ...action.payload };
    },
    resetInternationalFilters() {
      return initialState;
    },
  },
});

export const { setInternationalFilters, resetInternationalFilters } =
  internationalFilterSlice.actions;
export default internationalFilterSlice.reducer;
